export default __webpack_public_path__ + "static/media/red_option.883f5081.svg";